import React from "react";
import PropTypes from "prop-types";

import Text from "components/common/Text";
import Select from "components/common/Select";

import "./EligibilityField.scss";

const conditionOptions = [
  { value: "equals", label: "is equal to" },
  { value: "greater_than", label: "is greater than" },
  { value: "less_than", label: "is less than" },
  { value: "greater_than_equals", label: "is greater than or equal to" },
  { value: "less_than_equals", label: "is less than or equal to" },
];

const unitOptions = [
  { value: "days", label: "day(s)" },
  { value: "weeks", label: "week(s)" },
  { value: "months", label: "month(s)" },
  { value: "years", label: "year(s)" },
];

function EligibilityField({ field, value: valueFromProps, name, setFormValues, isDisabled = false }) {
  const { label } = field;

  const condition = valueFromProps?.condition || "equals";
  const fieldValue = valueFromProps?.value || "";
  const unit = valueFromProps?.unit || "days";

  const handleConditionChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        condition: newValue,
      },
    }));
  };

  const handleValueChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        value: e.target.value,
      },
    }));
  };

  const handleUnitChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        unit: newValue,
      },
    }));
  };

  return (
    <div className="eligibility-field">
      <label htmlFor="condition" className="eligibility-label dynamic-form-label-class">
        {label}
      </label>
      <div className="eligibility-inputs">
        <div className="color-text-headings-secondary para-body-m-regular">Tenure</div>
        <Select
          name="condition"
          className="condition-select"
          value={condition}
          onChange={handleConditionChange}
          options={conditionOptions}
          variant="outlined"
          size="small"
          label=""
          disabled={isDisabled}
        />
        <Text
          name="value"
          className="value-input"
          type="number"
          value={fieldValue}
          onChange={handleValueChange}
          variant="outlined"
          size="small"
          label=""
          hideHelperText
          disabled={isDisabled}
        />
        <Select
          name="unit"
          className="unit-select"
          label=""
          value={unit}
          onChange={handleUnitChange}
          options={unitOptions}
          variant="outlined"
          size="small"
          disabled={isDisabled}
        />
      </div>
    </div>
  );
}

EligibilityField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  value: PropTypes.shape({
    condition: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  setFormValues: PropTypes.func.isRequired,
};

EligibilityField.defaultProps = {
  value: {},
  isDisabled: false,
};

export default EligibilityField;
